import {
  type Exact,
  type ExactFormat,
  formatExact,
} from "@/lib/tool-kit/geometry/exact";
import {
  formatStyled,
  type NumberStyle,
  type Rational,
} from "@/lib/tool-kit/math/rational";

/**
 * How a worked solution writes its numbers: the decimal mark the reader's language
 * uses, and fractions (3/4) or decimals (0.75) — decimals when the reader typed any.
 */
export interface ResultFormat {
  mark: "." | ",";
  style: NumberStyle;
}

export const DEFAULT_FORMAT: ResultFormat = { mark: ".", style: "fraction" };

export function text(value: Rational, format: ResultFormat): string {
  return formatStyled(value, format.style, format.mark);
}

export function exactText(value: Exact, format: ResultFormat): string {
  const exactFormat: ExactFormat = {
    decimals: format.style === "decimal",
    mark: format.mark,
  };
  return formatExact(value, exactFormat);
}

/** A substituted value: bracketed when it is a fraction, as on paper. */
export function sub(value: Rational, format: ResultFormat): string {
  const written = text(value, format);
  return written.includes("/") ? `(${written})` : written;
}

export function decimalText(
  value: number,
  format: ResultFormat,
  places = 4
): string {
  const rounded = Number(value.toFixed(places)).toString();
  return format.mark === "," ? rounded.replace(".", ",") : rounded;
}
